import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';
import { LandingPageData } from '../shared/types/landing.types';
import { LandingService } from '../shared/landing.service';

const EMPTY_LANDING: LandingPageData = { heroBanner: null, categories: [] };

export const landingPageResolver: ResolveFn<LandingPageData> = () => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return of(EMPTY_LANDING);
  return inject(LandingService).fetchLandingPage().pipe(
    catchError(() => of(EMPTY_LANDING))
  );
};
